export const OperationType = {
    Installation: "INSTALLATION",
    Migration: "MIGRATION",
    UrlTransfer: "URL_TRANSFER",
    CompanyTransfer: "COMPANY_TRANSFER",
    CustomerTransfer: "CUSTOMER_TRANSFER",
    Delete: "DELETE",
    ForceDelete: "FORCE_DELETE",
    GetInstallationInfo: "GET_INSTALLATION_INFO",
    LicenseUpdate: "LICENSES_UPDATE",
    MenuUpdate: "MENU_UPDATE",
    GenerateBackup: "GENERATE_BACKUP",
    LicensesUpdateStatus: "LICENSES_UPDATE_STATUS",
    MenuUpdateStatus: "MENU_UPDATE_STATUS",
    GenerateBackupStatus: "GENERATE_BACKUP_STATUS"
};



// WEBPACK FOOTER //
// ./src/common/operationTypes.js